import { render, staticRenderFns } from "./EventsHorizontalList.vue?vue&type=template&id=3c901f5e"
import script from "./EventsHorizontalList.vue?vue&type=script&lang=js"
export * from "./EventsHorizontalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports